<template>
  <container
    subHeaderTitle="정보유출안심케어<br /><b>고객센터</b>"
    subHeaderText="해지처리가 완료되었습니다."
    subHeaderAlign="center"
  >
    <section class="form-area mb-180">
      <v-container class="py-0">
        <v-row justify="center">
          <v-col cols="12" md="6" sm="8">
            <v-divider class="mb-8" />
            <h3 class="help-info">기타 문의사항은 고객센터 또는 help@finbridge.co.kr 로 문의 부탁드립니다.</h3>
            <v-divider class="my-8" />
            <p>[고객센터]</p>
            <div class="pl-5 mt-2">
              <ul>
                <li>연락처 : 1688-4179</li>
                <li>업무시간 : 09:00 ~ 18:00 (주말, 공휴일 휴무)</li>
                <li>점심시간 : 12:00 ~ 13:00</li>
              </ul>
            </div>
            <div class="mt-12 mb-16 text-center">
              <v-btn class="result" rounded large depressed color="primary" v-if="result === 'SUCCESS'" @click.stop="$router.push({ name: 'Support' })">완료</v-btn>
              <v-btn class="result" rounded large depressed color="primary" v-else @click.stop="failCall()">확인</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- router Param 없을때 -->
    <v-dialog v-model="returnDialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4>정상적인 접근이 아닙니다.</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="goReturn()">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </container>
</template>

<script>
import Container from "@/pages/container/index.vue";
import PassSafeGuardResult from "@/views/csCenter/PassSafeGuardResult.vue";

export default {
  mixins: [PassSafeGuardResult],
  name: "SafeidResult",
  components: {
    Container
  },
  methods: {
    failCall() {
      this.$router.push({ name: "SafeidTermination" });
    },
    goReturn() {
      this.$router.push({ name: "Support" });
    }
  }
};
</script>
